// Мини-шкала плашки «Здесь»: интервал свойства места и пороги норм на одной оси.
//
// Порог, попавший внутрь интервала, — это и есть «зависит от точного места»:
// шкала показывает, почему фильтр не поставлен, вместо того чтобы сказать это
// словами.

export interface ScaleTick {
  value: number
  /** Положение на оси, 0…100 %. */
  pct: number
  /** Порог внутри интервала — ответ зависит от того, куда именно смотреть. */
  inside: boolean
}

export interface FactScale {
  lo: number
  hi: number
  ticks: ScaleTick[]
}

/** Ось берётся шире интервала и ближайших порогов, чтобы засечки не липли к
 *  краям; пороги дальше трёх ширин интервала на ось не попадают. */
export function factScale(interval: [number, number], thresholds: number[]): FactScale {
  const [a, b] = interval
  const width = Math.max(b - a, 1)
  const near = thresholds.filter(t => t >= a - 3 * width && t <= b + 3 * width)
  const min = Math.max(0, Math.min(a, ...near) - width * 0.5)
  const max = Math.max(b, ...near) + width * 0.5
  const span = max - min || 1
  const pct = (v: number) => Math.round(((v - min) / span) * 1000) / 10
  return {
    lo: pct(a),
    hi: pct(b),
    ticks: near.map(v => ({ value: v, pct: pct(v), inside: v > a && v < b })),
  }
}

/** Метров в пикселе на широте при зуме веб-меркатора (тайл 512 у MapLibre). */
export function metresPerPixel(zoom: number, lat: number): number {
  return (40_075_016.686 * Math.cos((lat * Math.PI) / 180)) / (512 * 2 ** zoom)
}

/** Окрестность клика — пять пикселей: столько занимает палец или неточная
 *  мышь. Прижимает её к границам сервер (`clamp_radius`). */
export const CLICK_RADIUS_PX = 5

export function clickRadius(zoom: number, lat: number): number {
  return Math.round(CLICK_RADIUS_PX * metresPerPixel(zoom, lat))
}
